import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})

export class MenuComponent implements OnInit {

  username: string;
  constructor(private router: Router) { }

  ngOnInit(): void { 
    this.username = localStorage.getItem('username');
  }

  redirectWamp(){
    window.open("http://wamp.iadb.org/","_blanck");
  }

  redirectCalendar(){
    window.open("https://idbg.sharepoint.com/sites/SEC/SitePages/ES/Home.aspx#/SecCalendarAgenda","_blanck");
  }

  start(){
    this.router.navigate(["/"]).then( r => {
      window.location.reload()
    })
  }
}
